import { PERMISSIONS } from '@/config/permissions.config.ts'

export const DEFAULT_ROUTE_PRIORITY = [
    {
        permission: PERMISSIONS.ADMIN_WEBSITES,
        route: '/admin/websites',
    },
    {
        permission: PERMISSIONS.ADMIN_API_KEYS,
        route: '/admin/api-keys',
    },
    {
        permission: PERMISSIONS.ADMIN_STATISTICS,
        route: '/admin/statistics',
    },
    {
        permission: PERMISSIONS.ADMIN_API_LOGS,
        route: '/admin/api-logs',
    },
    {
        permission: PERMISSIONS.ADMIN_UPDATES_PENDING,
        route: '/admin/updates/pending',
    },
    {
        permission: PERMISSIONS.ADMIN_UPDATES_COMPLETED,
        route: '/admin/updates/completed',
    },
    {
        permission: PERMISSIONS.ADMIN_UPDATES_FAILED,
        route: '/admin/updates/failed',
    },
    {
        permission: PERMISSIONS.ADMIN_USER_MANAGEMENT,
        route: '/admin/users',
    },
    {
        permission: PERMISSIONS.ADMIN_SYSTEM_SETTINGS,
        route: '/admin/system-settings',
    },
    {
        permission: PERMISSIONS.ADMIN_AUDIT_LOGS,
        route: '/admin/audit-logs',
    },
]

export const ROUTE_PERMISSIONS = {
    '/admin/websites': PERMISSIONS.ADMIN_WEBSITES,
    '/admin/api-keys': PERMISSIONS.ADMIN_API_KEYS,
    '/admin/statistics': PERMISSIONS.ADMIN_STATISTICS,
    '/admin/api-logs': PERMISSIONS.ADMIN_API_LOGS,
    '/admin/updates/pending': PERMISSIONS.ADMIN_UPDATES_PENDING,
    '/admin/updates/completed': PERMISSIONS.ADMIN_UPDATES_COMPLETED,
    '/admin/updates/failed': PERMISSIONS.ADMIN_UPDATES_FAILED,
    '/admin/users': PERMISSIONS.ADMIN_USER_MANAGEMENT,
    '/admin/system-settings': PERMISSIONS.ADMIN_SYSTEM_SETTINGS,
    '/admin/audit-logs': PERMISSIONS.ADMIN_AUDIT_LOGS,
}
